import { Grid, Box, Paper, Tabs, Tab } from "@mui/material";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";

export default function TicketingNav() {
  const { t } = useTranslation();
  const theme = useTheme();
  const location = useLocation();
  const [value, setValue] = useState("/reception/ticketing/tickets");

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/tickets")) {
      setValue("/reception/ticketing/tickets");
    } else if (path.includes("/queue")) {
      setValue("/reception/ticketing/queue");
    } else if (path.includes("/encounters")) {
      setValue("/reception/ticketing/encounters");
    } else if (path.includes("/approvals")) {
      setValue("/reception/ticketing/approvals");
    } else {
      setValue("/reception/ticketing/tickets");
    }
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
            }}
          >
            {[
              { path: "/reception/ticketing/tickets", label: "Tickets" },
              { path: "/reception/ticketing/queue", label: "Queue" },
              { path: "/reception/ticketing/encounters", label: "Encounters" },
              { path: "/reception/ticketing/approvals", label: "Approvals" },
            ].map((tab, index) => (
              <Tab
                key={index}
                style={{
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor:
                    value === tab.path ? theme.palette.primary.main : "white",
                  color: value === tab.path ? "white" : "black",
                }}
                label={tab.label}
                value={tab.path}
                component={NavLink}
                to={tab.path}
              />
            ))}
          </Tabs>
        </Paper>
        <Box sx={{ p: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </Grid>
  );
}
